<template>
	<div v-if="!store.state.featureSet.reportValidatedDocuments" class="p-grid nested-grid p-mx-2 p-pt-2">
		<div class="p-col-12 p-lg-12 p-xl-8 p-xxl-8">
			<div class="p-grid">
				<div class="p-col-12 p-lg-6 p-xl-6 p-xxl-6">
					<DashboardTile class="dashboard-tile">
						<DocumentReportOrigin />
					</DashboardTile>
				</div>
				<div class="p-col-12 p-lg-6 p-xl-6 p-xxl-6">
					<DashboardTile class="dashboard-tile">
						<DocumentReportExports />
					</DashboardTile>
				</div>
			</div>
		</div>
		<div class="p-col-12 p-lg-6 p-xl-4 p-xxl-4">
			<DashboardTile class="dashboard-tile">
				<DocumentReportProcessed />
			</DashboardTile>
		</div>
		<div class="p-col-12 p-lg-6 p-xl-6 p-xxl-6">
			<DashboardTile class="dashboard-tile">
				<DocumentReportExportedDocuments />
			</DashboardTile>
		</div>
		<div class="p-col-12 p-lg-12 p-xl-6 p-xxl-6">
			<DashboardTile class="dashboard-tile">
				<DocumentReportAutovalidation />
			</DashboardTile>
		</div>
	</div>

	<!-- When more then 5 reports -->
	<div v-else class="p-grid nested-grid p-mx-2 p-pt-2">
		<div class="p-col-12 p-xxl-8">
			<div class="p-col-12 p-pl-0 p-pr-0 p-mb-2">
				<DashboardTile class="dashboard-tile">
					<DocumentReportFieldSelectionQuality />
				</DashboardTile>
			</div>
			<div class="p-grid">
				<div class="p-col-12 p-xxl-6">
					<DashboardTile class="dashboard-tile">
						<DocumentReportExportedDocuments />
					</DashboardTile>
				</div>
				<div class="p-col-12 p-xxl-6">
					<DashboardTile class="dashboard-tile">
						<DocumentReportExports />
					</DashboardTile>
				</div>
			</div>
		</div>
		<div class="p-col-12 p-xxl-4 p-pt-3">
			<div class="p-grid">
				<div class="p-col-12">
					<DashboardTile class="dashboard-tile">
						<DocumentReportAutovalidation />
					</DashboardTile>
				</div>
				<div class="p-col-12">
					<DashboardTile class="dashboard-tile">
						<DocumentReportProcessed />
					</DashboardTile>
				</div>
				<div class="p-col-12">
					<DashboardTile class="dashboard-tile">
						<DocumentReportOrigin />
					</DashboardTile>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DashboardTile from "@/components/DashboardTile.vue";
import DocumentReportExportedDocuments from "@/apps/squeeze/components/DocumentReportExportedDocuments.vue";
import DocumentReportExports from "@/apps/squeeze/components/DocumentReportExports.vue";
import DocumentReportOrigin from "@/apps/squeeze/components/DocumentReportOrigin.vue";
import DocumentReportProcessed from "@/apps/squeeze/components/DocumentReportProcessed.vue";
import DocumentReportAutovalidation from "@/apps/squeeze/components/DocumentReportAutovalidation.vue";
import useSqueezeStore from "@/apps/squeeze/store";
import DocumentReportFieldSelectionQuality from "@/apps/squeeze/components/DocumentReportFieldSelectionQuality.vue";

export default defineComponent({
	name: "Reports",
	components: {
		DocumentReportFieldSelectionQuality,
		DocumentReportAutovalidation,
		DocumentReportProcessed,
		DocumentReportOrigin,
		DocumentReportExports,
		DocumentReportExportedDocuments,
		DashboardTile,
	},
	setup() {
		/** Vuex Store */
		const store = useSqueezeStore();

		return {
			store,
		};
	},
});

</script>

<style lang="scss" scoped>

@media screen and (min-width: 1500px) {
	.p-xxl-1 {
		width: 8.33%;
	}
	.p-xxl-2 {
		width: 16.67%;
	}
	.p-xxl-3 {
		width: 25%;
	}
	.p-xxl-4 {
		width: 33.33%;
	}
	.p-xxl-5 {
		width: 41.67%;
	}
	.p-xxl-6 {
		width: 50%;
	}
	.p-xxl-7 {
		width: 58.33%;
	}
	.p-xxl-8 {
		width: 66.67%;
	}
	.p-xxl-9 {
		width: 75%;
	}
	.p-xxl-10 {
		width: 83.33%;
	}
	.p-xxl-11 {
		width: 91.67%;
	}
	.p-xxl-12 {
		width: 100%;
	}
}

@media screen and (min-width: 1800px) {
	.p-xxl-1, .p-xxl-2, .p-xxl-3, .p-xxl-4, .p-xxl-5, .p-xxl-6, .p-xxl-7, .p-xxl-8, .p-xxl-9, .p-xxl-10, .p-xxl-11, .p-xxl-12 {
		flex: 0 0 auto;
	}
}

::v-deep(.p-inputtext) {
	padding: 0.7rem 0.7rem;
}

.dashboard-tile {
	padding: 1rem !important;
}

</style>
